export default {
  lang: {
    selectAll: 'Επιλογή όλων των σελίδων',
    selected: 'Επιλεγμένα',
    term: 'Άρθρο',
    deselect: 'Αποεπιλογή',
  },
};
